import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
const OTX_INDICATORS = [
  { label: "otx_adapter_field_set.option_ip_auto_detect", value: "IPAutoDetect" },
  { label: "otx_adapter_field_set.option_ip_v4", value: "IPv4" },
  { label: "otx_adapter_field_set.option_ip_v6", value: "IPv6" },
  { label: "otx_adapter_field_set.option_domain", value: "domain" },
  { label: "otx_adapter_field_set.option_hostname", value: "hostname" },
  { label: "otx_adapter_field_set.option_file", value: "file" },
  { label: "otx_adapter_field_set.option_url", value: "url" },
  { label: "otx_adapter_field_set.option_cve", value: "cve" },
  { label: "otx_adapter_field_set.option_nids", value: "nids" },
  { label: "otx_adapter_field_set.option_correlation_rule", value: "correlation-rule" }
];
const OTXAdapterFieldSet = ({ updateConfig, config, handleFormEvent, validationState, validationMessage }) => {
  const { t } = useTranslation("integrations");
  const handleSelect = (fieldName) => (selectedIndicator) => {
    const newConfig = cloneDeep(config);
    newConfig[fieldName] = selectedIndicator;
    updateConfig(newConfig);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "indicator",
      label: t("otx_adapter_field_set.indicator_label"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("indicator", t("otx_adapter_field_set.indicator_help")),
      bsStyle: validationState("indicator"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: t("otx_adapter_field_set.indicator_placeholder"),
        clearable: false,
        options: OTX_INDICATORS.map((indicator) => ({ ...indicator, label: t(indicator.label) })),
        onChange: handleSelect("indicator"),
        value: config.indicator
      }
    )
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "api_key",
      name: "api_key",
      label: t("otx_adapter_field_set.api_key_label"),
      onChange: handleFormEvent,
      help: validationMessage("api_key", t("otx_adapter_field_set.api_key_help")),
      bsStyle: validationState("api_key"),
      value: config.api_key,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "api_url",
      name: "api_url",
      label: t("otx_adapter_field_set.api_url_label"),
      onChange: handleFormEvent,
      help: validationMessage("api_url", t("otx_adapter_field_set.api_url_help")),
      bsStyle: validationState("api_url"),
      value: config.api_url,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "http_user_agent",
      name: "http_user_agent",
      label: t("otx_adapter_field_set.user_agent_label"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("http_user_agent", t("otx_adapter_field_set.user_agent_help")),
      bsStyle: validationState("http_user_agent"),
      value: config.http_user_agent,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "http_connect_timeout",
      name: "http_connect_timeout",
      label: t("otx_adapter_field_set.connect_timeout_label"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("http_connect_timeout", t("otx_adapter_field_set.connect_timeout_help")),
      bsStyle: validationState("http_connect_timeout"),
      value: config.http_connect_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "http_write_timeout",
      name: "http_write_timeout",
      label: t("otx_adapter_field_set.write_timeout_label"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("http_write_timeout", t("otx_adapter_field_set.write_timeout_help")),
      bsStyle: validationState("http_write_timeout"),
      value: config.http_write_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "http_read_timeout",
      name: "http_read_timeout",
      label: t("otx_adapter_field_set.read_timeout_label"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("http_read_timeout", t("otx_adapter_field_set.read_timeout_help")),
      bsStyle: validationState("http_read_timeout"),
      value: config.http_read_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ));
};
export default OTXAdapterFieldSet;
